import { useMemo } from 'react';
import { useQuery } from 'convex/react';
import { api } from '@bill-alps/backend/convex/_generated/api';
import { IS_DATA_IMPORT } from '@/lib/runtime/feature-flags';
import type { MaybeJob } from './sandbox-job';

/**
 * The most recent sandbox import for this account — the one row every sandbox
 * surface reads (route gate, setup page, banner, account section).
 *
 * Outside a sandbox build the query is skipped and the hook answers `null`
 * rather than `undefined`: `undefined` means "still loading" everywhere else,
 * and a skipped query never resolves — so a normal build opens no
 * subscription, whatever the deployment would have answered.
 *
 * `clerkId` is the staff-only override (`?clerkId=` on the setup page); a
 * non-admin passing one is answered with `null` by the backend.
 */
export function useSandboxJob(clerkId?: string): MaybeJob {
  const args = useMemo(() => (clerkId ? { clerkId } : {}), [clerkId]);
  const job = useQuery(
    api.features.sandboxImport.jobs.getMyJob,
    IS_DATA_IMPORT ? args : 'skip',
  );
  return IS_DATA_IMPORT ? job : null;
}
